import {
  DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_BEGIN,
  DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_SUCCESS,
  DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_FAILURE,
  DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function loadProjectExternalDbCollections(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_BEGIN,
    });
    const { projectId, version, externalDatabaseId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project/externaldatasource`;

      if (externalDatabaseId) {
        url += '?';
        if (externalDatabaseId) url += `externalDatabaseId=${externalDatabaseId}&`;
      }

      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectExternalDbCollectionsError() {
  return {
    type: DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_BEGIN:
      return {
        ...state,
        loadProjectExternalDbCollectionsPending: true,
        loadProjectExternalDbCollectionsError: null,
      };

    case DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loadProjectExternalDbCollectionsPending: false,
        loadProjectExternalDbCollectionsError: null,
        collectionsExternalDataSources: action.data,
      };

    case DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_FAILURE:
      return {
        ...state,
        loadProjectExternalDbCollectionsPending: false,
        loadProjectExternalDbCollectionsError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_PROJECT_EXTERNAL_DB_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        loadProjectExternalDbCollectionsError: null,
      };

    default:
      return state;
  }
}
